//数组去重
export function shotSecond(arr) {
    var newArr = arr.reduce(function (prev, cur) {
        prev.indexOf(cur) === -1 && prev.push(cur);
        return prev;
    }, []);

    return newArr;
}

//获取URL参数
export function getUrlParam(name) {
    // 取得url中?后面的字符
    var query = window.location.search.substring(1);
    // 把参数按&拆分成数组
    var param_arr = query.split("&");
    for (var i = 0; i < param_arr.length; i++) {
        var pair = param_arr[i].split("=");
        if (pair[0] == name) {
            return pair[1];
        }
    }
    return (false);
}

export function getHost() {
    let url = window.location.protocol + '//' + window.location.host;
    return url;
}


//时间戳转日期
export function formatDate(time, type = 1) {
    if (time > 0) {
        var date = new Date();
        date.setTime(time * 1000);
        var year = date.getFullYear();  //取得4位数的年份
        var month = date.getMonth() + 1;  //取得日期中的月份，其中0表示1月，11表示12月
        var day = date.getDate();      //返回日期月份中的天数（1到31）
        var hour = date.getHours();     //返回日期中的小时数（0到23）
        var minute = date.getMinutes(); //返回日期中的分钟数（0到59）
        var second = date.getSeconds(); //返回日期中的秒数（0到59）
        if (type === 2) {
            return year + "/" + month;
        }
        if (type === 'time') {
            return year + "/" + month + "/" + day + " " + hour + ":" + minute + ":" + second
        }
        return year + "/" + month + "/" + day;
    } else {
        return '';
    }
}

export function getLastUrl(url = '') {
    var strUrl;
    if(url !== ''){
        strUrl = url;
    }else{
        strUrl = window.location.href;
    }
    var arrUrl = strUrl.split("/");
    var strPage = arrUrl[arrUrl.length - 1];
    if (strPage.indexOf("?") > -1) {
        var pageName = strPage.split("?");
        strPage = pageName[0];
    }
    return strPage;
}


// export {
//     shotSecond,
//     getUrlParam,
//     getHost,
//     formatDate,
//     getLastUrl
// }